
import TableList from "@components/templates/tablelist";
import { HttpPackageList, HttpExportPackage, HttpDelPackage, HttpClearPackage } from '@/service/inbound';
export default {
    props: ['status'],
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true, align: 'right' },
            formData: {
                // search:{
                //     EQ_invalid:0
                // }
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpPackageList,
        interceptRequest(params){
            params.search.EQ_invalid = 0;
            return params
        },
        updateParent() {
            this.$emit('on-update');
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = params || this.checkedData;
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            const id = this.formData["id"];
            switch (type) {
                case 'del':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: this.$t('global.common.delete', { defaultValue: "删除" }),
                        params: { id, boxItemIds: this.checkedData },
                        ajaxRequest: HttpDelPackage,
                        callback: this.updateParent
                    };
                    break;
                case 'clear':
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.clear', { defaultValue: "清空" }),
                        params: { id },
                        ajaxRequest: HttpClearPackage,
                        callback: this.updateParent
                    };
                    break;
                case 'export':
                    this.handleWebfs(HttpExportPackage, this.formData, { executor: 'request', download: true });
                    break;
            }
        }
    },
    computed: {
        ToolsData() {
            return [{
                name: this.$t('global.common.delete', { defaultValue: "删除" }),
                operate: "del",
                theme: "warning",
                show: this.status === 'boxing',
                batch: true,
            },{
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                operate: "export",
                theme: "primary",
            },{
                name: this.$t('global.common.clear', { defaultValue: "清空" }),
                operate: "clear",
                theme: "default",
                show: this.status === 'boxing'
            },]
        },
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'EQ_sku',
                show: true,
            },
            {
                label: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
                tag: 'vInput',
                key: 'EQ_boxBarcode',
                show: true,
            }]
        },
        columns() {
            return [{
                type: 'selection',
                width: this.status === 'boxing' ? 60 : 0,
                formName: 'id',
            }, {
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'sku'
            }, {
                title: this.$t('fbb.inbound.box_in_number', { defaultValue: "装箱入数" }),
                key: 'packedQty'
            }, {
                title: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
                key: 'boxBarcode'
            }, {
                title: this.$t('fbb.inbound.outer_box_size', { defaultValue: "外箱长宽高(cm)" }),
                key: 'cartonLength',
                render(h, { row }) {
                    return `${row.cartonLength}*${row.cartonWidth}*${row.cartonHeight}`
                }
            }, {
                title: this.$t('fbb.inbound_outer_box_weight', { defaultValue: "外箱毛重(kg)" }),
                key: 'cartonGrossWeight',
                render(h, { row }) {
                    return (row.cartonGrossWeight / 1000).toFixed(4)
                }
            }, {
                title: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                key: 'createdAt'
            }]
        }
    }
};
